<template>
    <div class="hpResort">
        <div class="container">
          <!--
            <div class="fade_img" style="padding-bottom:20px;">
                <img width="500px" height="auto" 
                src="http://www.mis-implants.com/img/product-logos/CONNECT.svg" />
            </div>-->
            <div class="split-text title"><p>HILTON CANCUN</p></div>  
            <div class="split-text title"><p>AN ALL-INCLUSIVE RESORT</p></div>  
            <br/>
            <div class="split-text hilton-text">Set on a secluded stretch of Mayan coastline, Hilton Cancun, an All Inclusive Resort, feels like a lost paradise with the perfect blend of Mexican heritage and modern sophistication. Here, with panoramic ocean views, authentic global cuisine, oceanfront pools, and a wealth of unexpected delights, it's possible to be endlessly entertained yet infinitely relaxed and no two journeys are exactly alike.</div>  
        </div>
        <div class="xrImgCircleItems">
            <div style="--index:0" class="xrImgCircle" @click="openGal"><div class="xrImg" style="background-image: url('img/cancun/hilton1.jpg')"></div></div>
            <div style="--index:1" class="xrImgCircle" @click="openGal"><div class="xrImg" style="background-image: url('img/cancun/hilton2.jpg')"></div></div>
            <div style="--index:2" class="xrImgCircle" @click="openGal"><div class="xrImg" style="background-image: url('img/cancun/hilton3.jpg')"></div></div>
        </div>        
        <div class="xrBtns">
            <a class="white_btn animation_up" target="_blank" href="https://www.hilton.com/en/hotels/cunqrhh-hilton-cancun/?SEO_id=GMB-AMER-HI-CUNQRHH&y_source=1_Mjc2Mjg5OTgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D">
              <span class="title">Hotel info</span><i class="fal fa-chevron-right pl-s" ></i>
            </a>
            <a class="white_btn animation_up" @click="openHiltonMap">
              <span class="title">View map</span><i class="fal fa-chevron-right pl-s" ></i>
            </a>

        </div>

    </div>
</template>
<style>    
    .hpResort
    {
      width: 100%;
    }
    .hpResort .container
    {
      max-width: 1200px;
      width: 85vw;
    }
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/
    .fade_img
    {
        opacity: 0;
        transition:all ease-in-out 1s;
        transition-delay: 0.1s;
        transform: translateY(20px);
    }
    .reveal.active .fade_img
    {      
        opacity: 1;transform: translateY(0px);
    }
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/

  .hpResort .split-text.title .xLine .xLineText
  {
    font-weight: 200 !important;
  }

    .hpResort .split-text.hilton-text,
    .hpResort .split-text.hilton-text .xLine .xLineText
    { 
      font-weight: 100 !important;      
      font-size: 24px;
      line-height: 28px;      
    }
    .hpResort .split-text.hilton-text{
      letter-spacing: 0px !important;}
    .hpResort .split-text.hilton-text .xLine .xLineText{
      letter-spacing: -0.5px !important;}

  .hpResort .xrImgCircleItems
  {
    display: grid;
    justify-items: center;
    grid-template-columns: 1fr 1fr 1fr !important;  
    align-items: center;
    padding-top:10px;clear:both;
    width:700px;margin:auto;
    cursor: pointer;
  }
  .hpResort .xrImgCircle
  {
    opacity: 0;
    clip-path: circle(76px at center);
    position: relative;
    background-color:rgba(255,255,255,0.15);
    width: 220px;height: 220px;
  }
  .hpResort .xrImgCircle .xrImg
  {
    opacity: 1;
    position: absolute;
    width: 220px;height: 220px;
    background-size: 100%;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center center;    
    clip-path: circle(73px at center);
    transition: all ease-in-out 0.3s;
  }
  .clip-circle 
  {
    clip-path: circle(40px at center);
    /* OLD VALUE example: circle(245px, 140px, 50px); */
    /* Yep, even the new clip-path has deprecated stuff. */
  }


  @media (max-width: 850px) { 
    .hpResort .container{
      width: 85vw;padding: 0px;
    }
    .hpResort .container .title div{
      font-size: 24px !important;line-height: 30px;
    }


    .hpResort .split-text.hilton-text,
    .hpResort .split-text.hilton-text .xLine .xLineText
    { 
      font-weight: 100 !important;
      letter-spacing: 0px !important;
      font-size: 18px;
      line-height: 22px;      
    }

    .hpResort .xrImgCircleItems{
      width:100%;
      margin:auto;
      display: block;
      position: relative;
      height:220px;
    }
    .hpResort .xrImgCircle{
      position: absolute;transform: none;
    }    
    .hpResort .xrImgCircle:nth-child(1){
      left: calc(50vw - 110px - 140px);
    }
    .hpResort .xrImgCircle:nth-child(2){
      left: calc(50vw - 110px);/* item size is 160/2 = 80 */
    }
    .hpResort .xrImgCircle:nth-child(3){
      left: calc(50vw - 110px + 140px);
    }

   }

    @media (hover:hover) {
      .hpResort .xrImgCircle
      {
        transition: all ease 0.2s;
      }
      .hpResort .xrImgCircle:hover
      {        
        background-color:rgba(255,255,255,0.3);
      }            
    }


    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {
        .xrBtns{
          width: 50% !important;
        }
    }

    /* Landscape iPad mini 1, iPad 1 and iPad 2 */
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: landscape)
    {

    }   
</style>

<script>
import { mapActions, mapState } from "vuex";
import { splitLines }         from "@/utils";

export default {
  name: "hpPros",
  methods: {
    openGal(){
      this.$emit('open-gal');
    },
    openHiltonMap(){
      this.$emit('open-map');
    },
  },
  computed: {
    ...mapState(["pageLayoutData", "locale", "dirtyHome"]),
  }
};
</script>

